import distinctColors from 'distinct-colors';

export default class Colorizer {
    constructor() {
        this.predefinedColors = [
            { r: 57, g: 106, b: 177 },
            { r: 218, g: 124, b: 48 },
            { r: 62, g: 150, b: 81 },
            { r: 204, g: 37, b: 41 },
            { r: 83, g: 81, b: 84 },
            { r: 107, g: 76, b: 154 },
            { r: 146, g: 36, b: 40 },
            { r: 148, g: 139, b: 61 }
        ];
    }

    generatePalette(count) {
        const generatedColorsCount = count - this.predefinedColors.length;
        if (generatedColorsCount > 0) {
            return [...this.predefinedColors, ...distinctColors({
                count: generatedColorsCount,
                lightMin: 35,
                lightMax: 100,
                hueMin: 0,
                hueMax: 360,
                chromaMin: 0,
                chromaMax: 100
            }).map(p => {
                const rgba = p.rgba();
                return { r: rgba[0], g: rgba[1], b: rgba[2] };
            })];
        } else {
            return this.predefinedColors.slice(0, count);
        }
    }

    colorize({ projects, groups }) {
        const projectsLength = projects ? projects.length : 0;
        const groupsLength = groups ? groups.length : 0;
        const palette = this.generatePalette(projectsLength + groupsLength);
        const projectsPalette = palette.slice(0, projectsLength);
        const groupsPalette = palette.slice(projectsLength);
        return {
            projects: projects.map((p, i) => ({
                ...p,
                color: projectsPalette[i]
            })),
            groups: groups.map((g, i) => ({
                ...g,
                color: groupsPalette[i]
            }))
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/shared/colorizer/colorizer.service.js